import { useEffect } from 'react';
import MultiSelect from 'common/data-entry/MultiSelect/MultiSelect';

import {
  initializeProcessor,
  setValueProcessor as defaultSetValueProcessor
} from 'components/eui/EuiFiltersContext/processors';
import { FRS_READY, FRS_UNINITIALIZED } from 'components/eui/EuiFiltersContext/reducer';

import useFilterSyncCache from '../../hooks/useFilterSyncCache';

export default function BasicMultiselect({
  uniqKey,
  state,
  dispatch,
  getOptions = defaultGetOptions,
  label,
  customOptionTemplateFunction,
  customSelectedValueTemplateFunction,
  initializeOptions = true,
  setValueProcessor = defaultSetValueProcessor,
  syncCache = true,
  ...rest
}) {
  const fState = state[uniqKey];
  const status = state.schema[uniqKey].status;

  useEffect(
    function() {
      if (!initializeOptions) {
        return;
      }
      if (status === FRS_UNINITIALIZED) {
        getOptions().then(function(payload) {
          dispatch({
            type: 'PERFORM',
            processor: initializeProcessor,
            payload: {
              key: uniqKey,
              ...payload
            }
          });
        });
      }
    },
    [uniqKey, dispatch, status, getOptions, initializeOptions]
  );

  useFilterSyncCache({ uniqKey, disabled: !syncCache });

  if (status !== FRS_READY) return null;

  const { source, value } = fState;
  return (
    <MultiSelect
      data-testid={rest['data-testid']}
      label={label}
      searchable
      clearSearchOnSelection
      dataSource={source}
      onChange={selectedOptions => {
        dispatch({
          type: 'PERFORM',
          processor: setValueProcessor,
          payload: {
            key: uniqKey,
            value: selectedOptions
          }
        });
      }}
      value={value}
      validate={false}
      customOptionTemplateFunction={customOptionTemplateFunction}
      customSelectedValueTemplateFunction={customSelectedValueTemplateFunction}
    />
  );
}

function defaultGetOptions() {
  return Promise.resolve();
}
